import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {BaseConverter} from './converters/base.converter';
import toUrl from '../../higherOrderFunction/toUrl';

@Injectable({
  providedIn: 'root'
})
export class BaseDao<ViewModel> {

  constructor(private httpClient: HttpClient,
              private baseConverter: BaseConverter<ViewModel>) {
  }

  public find(url: string, params: any[], query: {}, factory): Observable<ViewModel[]> {
    const finalUrl = toUrl(url, params, query);
    const response = this.httpClient.get<Object[]>(finalUrl);

    return response
      .pipe(
        map(body => this.baseConverter.toViewModels(body, factory))
      );
  }

  public get<T>(url: string, params: any[], query: {}, factory): Observable<T> {
    const finalUrl = toUrl(url, params, query);
    const response = this.httpClient.get<T>(finalUrl);

    return response;
  }
}
